/**
 * Application Configuration
 * 
 * This file provides configuration settings for the EMU Data Customer Portal
 */

// API configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ThingStack configuration
export const TTN_AU1_API_URL = 'https://au1.cloud.thethings.network';
export const TTN_EU1_API_URL = 'https://eu1.cloud.thethings.network';
export const TTN_API_KEY = 'NNSXS.AQH66UDBOCDD6Q2EB532TTVZHO3OEDOJUEK7J2I.KAAG2WKIZGN6HQNDO53NS2TDTNX5FFPOLWXOKON6LKPRYX5IGUCQ';
export const TTN_APPLICATION_ID = process.env.REACT_APP_TTN_APPLICATION_ID || 'water-meter-connection';

// Clint's device configuration
export const CLINT_DEVICE_EUI = 'eui-8254812410000102';
export const CLINT_WATER_COST_RATE = 0.004209; // Cost per liter
export const CLINT_DAILY_THRESHOLD = 100000; // Daily threshold in liters (100 m³)

// AWS API configuration for water meter data
// Note: This URL would normally come from the AWS CloudFormation deployment output
export const WATER_METER_API_URL = process.env.REACT_APP_WATER_METER_API_URL || 'https://f1uyig4hn2.execute-api.ap-southeast-2.amazonaws.com/prod/water-meter-data';
export const USE_AWS_API = true; // Set to true to use AWS API instead of ThingStack

// Application settings
export const FALLBACK_MODE = false; // Override fallback mode to use live data

// UI configuration
export const METER_IMAGES_PATH = process.env.REACT_APP_METER_IMAGES_PATH || '/meters'; 